import { Component, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConditionConfig } from '@core/models/built/procedure-step-config.model';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { filterTruthy } from '@utils';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/condition-report.it.json';

@Component({
  templateUrl: './condition-report.component.html',
  styleUrls: ['./condition-report.component.scss']
})
export class ConditionReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  codeEditorOptions = {
    theme: 'vs-dark',
    language: 'javascript',
    readOnly: true,
    minimap: { enabled: false }
  };

  conditionForm$ = this.step$.pipe(
    map(step => {
      const { code } = step.procedureStep?.config as ConditionConfig;
      return this.fb.group({
        code: [{ value: code, disabled: true }]
      });
    }),
    filterTruthy()
  );

  targetResult$ = this.step$.pipe(
    map(step => {
      const v = step.values ? step.values[0] : undefined;
      return v ? (v.value as InputJson).input : 'error';
    })
  );

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  viewCode(codeTmpl: TemplateRef<any>) {
    this.dialog.open(codeTmpl, { data: {} });
  }

}
